import React from 'react';

import { event_path } from '../../../routes.js';
import { Event } from '../../../utils/backend-api/events';
import styles from './styles.module.scss';

const EventCard = ({ image, highlight, name, date, location, slug }: Event) => {
  return (
    <div className={styles.eventContainer}>
      <div className={styles.eventImageContainer}>
        <a href={event_path(slug)}>
          <img src={image} alt={name} />
        </a>
      </div>
      <div className={styles.eventHighlight}>
        <a className={styles.highlightLink} href={event_path(slug)}>
          {highlight}
        </a>
      </div>
      <a href={event_path(slug)}>
        <div className={styles.eventTitle}>{name}</div>
        <div className={styles.eventTimeDetail}>
          {date} | {location}
        </div>
      </a>
    </div>
  );
};

export default EventCard;
